/**
 * The apothecary's hanging chandelier (lifted from lantern-water's `world.js`
 * `createShop`): an iron drop, a brass ring and five candles with their halos.
 * Origin: under its centre on the floor. No params. Its point light is the
 * scene's.
 */
import * as THREE from 'three';
import { candle } from '../apothecary.ts';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'chandelier',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    const { m } = ctx;
    ctx.line(root, [0, 4.7, 0], [0, 3.8, 0], 0.035, m.iron);
    ctx.cylinder(root, 0, 3.74, 0, 0.62, 0.065, m.brass);
    for (let i = 0; i < 5; i += 1) {
      const a = (i / 5) * 6.28;
      candle(ctx, root, Math.cos(a) * 0.52, 3.8, Math.sin(a) * 0.52);
    }
    return { root, sockets: { light: [0, 3.6, 0] } };
  },
};
